<template>
    <div class="container">
      <div class="is-mobile" style="height: 20px;"></div>
     
      <div class="row help-row">
        <div class="col-xl-3 mb-5 mb-lg-0">
          <subtitle style="font-size: 24px;color: #002626;">{{ $t("documentList.title") }}</subtitle>
           
          <div style="display: flex;flex-direction: row;margin-top: 33px;">
            <span style="display: inline-block;font-size: 14px;color: #000;text-align: center;">
              {{ this.$t("documentList.support_title") }}
            </span>
          </div>
    
          <div style="display: flex;flex-direction: row;">
            <span style="display: inline-block;font-size: 14px;color: #000;background-color: white;">
              {{ this.$t("documentList.support_subtitle_1") }}
            </span>
            <a style="margin-left: 5px;" href="/assistenza">{{this.$t("documentList.support_subtitle_2")}}</a>
          </div>

        </div>
        <div class="col-lg-6">
          <ul v-if="this.$store.state.userDocuments.length > 0" style="padding-bottom: 30px;">
            <li v-for="item in this.$store.state.userDocuments" :key="item.title" style="border-radius: 5px;display: flex;flex-direction: row;">
              <div @click="goToDownload(item)" style="display: flex;flex: 1; flex-direction: row;align-items: center;margin-bottom: 11px; background-color: white;padding-top: 16px;padding-bottom: 16px;border-radius: 5px;border: solid 1px #e8ecee;">

                    <div style="display: flex;flex-direction: column;margin-left: 15px;">
                        <span style="font-size: 18px;color: #000;font-weight: bold;margin-top: 3px;">
                        {{item.title}}
                        </span>
                    </div>
                    <div style="display: flex;flex: 1;"></div>
                     <div style="height: 100%;align-items: center;justify-items: center;margin-right: 25px;">
                        <div style="display: flex;align-items: center;justify-items: center;">
                            <img :alt="$t('documentList.imgTitle',{documentName: item.title})" :title="$t('documentList.imgTitle',{documentName: item.title})" :src="icoDownload"> 
                        </div>
                      </div>
                </div>
               
            </li>
          </ul>
        <div style="width: 100%;min-height: 100px;display: flex;align-items: center;justify-content: center;">

      </div>
       <div style="height: 97px;"></div>
        </div>
      </div>
    </div>
  
</template>

<script>
import Subtitle from "@/components/Subtitle";
import icoDownload from '../assets/ico-download.svg'

export default {
  name: 'DocumentList',
  components: {
    Subtitle,
  },
  props: ['type'],
  data: function () {
    return {
      icoDownload:icoDownload
    }
  },
  methods: {
    goToDownload: function(item) {
      window.open(item.pdfURL, '_blank');
    }
  },
  async created() {

    this.$store.commit('setLoader', true);

    await this.axios.get(process.env.VUE_APP_API_DWH_URL + 'client-contracts', this.authDWHSetting)
        .then((response) => {
          this.$store.commit('setUserDocumentList',response.data);
          this.$store.commit('setLoader', false);
        }).catch(() => {
          this.$store.commit('setLoader', false);
        });
  },
  mounted() {
    
  }
}
</script>
<style lang="scss" scoped>
.help {
  background-color: var(--grey);
  padding: 0 0 24px;

  @include bp($md) {
    padding: 0 0 80px;
  }

  &-row {
    @include bp($md) {
      padding-top: 35px;
    }
  }

  &-subtitle {
    opacity: 0.5;
    font-size: 16px;
    font-weight: normal;
    line-height: normal;
    color: var(--title-color);
  }

  &-contacts {
    margin: 0;
    padding: 0;
    list-style: none;

    &-title {
      margin: 25px 0 12px;
      opacity: 0.72;
      font-size: 14px;
      font-weight: normal;
      line-height: 1;
      letter-spacing: normal;
      color: var(--black);
    }

    &-content {
      font-size: 24px;
      line-height: 1;
      letter-spacing: normal;
      color: var(--black);
    }

    &-hours {
      margin: 12px 0 18px;
      opacity: 0.48;
      font-size: 14px;
      line-height: 1;
      letter-spacing: normal;
      color: var(--black);
    }
  }

  &-form {
    &-title {
      opacity: 0.8;
      font-size: 12px;
      font-weight: bold;
      color: var(--title-color);
      text-transform: uppercase;
      margin: 0 0 25px;
    }
  }


}

</style>